import { NumberInputModule, ServiceResponseModule } from '@sdbn/appclient';
import { BasicarticleAttributesComponent } from './basicarticle-attributes/basicarticle-attributes.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';

import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonDateModule } from '@sdbn/appclient';
import { BasicArticleAdminComponent } from './basicarticle-admin/basicarticle-admin.component';
import { BasicarticleArticletypeComponent } from './basicarticle-articletype/basicarticle-articletype.component';
import { BasicarticleEditorComponent } from './basicarticle-editor/basicarticle-editor.component';



@NgModule({
  declarations: [
    BasicArticleAdminComponent,
    BasicarticleAttributesComponent,
    BasicarticleArticletypeComponent,
    BasicarticleEditorComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
    MaterialModule,
    ReactiveFormsModule,
    DictionaryModule,
    SharedModule,
    CommonDateModule,
    NumberInputModule,
    ServiceResponseModule
  ]
})
export class BasicArticeModule {

}
